import React from "react";
import EmptyPage from "../../components/EmptyPage";

const Backup = () => {
  return (
    <EmptyPage
      title="Backup Settings"
      description="Configure automated backups, manage backup schedules, and restore data to ensure your real estate information is always protected."
      icon="💾"
    />
  );
};

export default Backup;
